<div *ngIf="!resultShow" [ngClass]="{'henterpant-mode': henterPantMode, 'gipant-mode': giPantMode}">
  <h2 class="title">{{'FORGOT_PASSWORD.TITLE' | translate}}</h2>
  <p class="description" [innerHTML]="'FORGOT_PASSWORD.DESCRIPTION' | translate"></p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" >
    <!-- Email -->
    <div class="form-group">
      <label for="email">{{'FORGOT_PASSWORD.EMAIL' | translate}} <span class="req">*</span></label>
      <input id="email" type="email" formControlName="email" class="form-control" />
      <div *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
        <small *ngIf="form.get('email')?.errors?.['required']" class="text-danger">
          {{'FORGOT_PASSWORD.ERRORS.EMAIL_REQUIRED' | translate}}
        </small>
        <small *ngIf="form.get('email')?.errors?.['email']" class="text-danger">
          {{'FORGOT_PASSWORD.ERRORS.EMAIL_INVALID' | translate}}
        </small>
      </div>
    </div>

    <small *ngIf="error" class="text-danger">
      {{errorText ? errorText : ('FORGOT_PASSWORD.ERRORS.GENERIC' | translate)}}
    </small>

    <div class="button-wrap">
      <button *ngIf="henterPantMode"
        type="button"
        class="btn btn-secondary"
        (click)="goLoginStage()">
        {{'FORGOT_PASSWORD.BUTTON_BACK' | translate}}
      </button>
      <button type="submit" class="btn with-loader {{henterPantMode ? 'btn-primary-henterpant' : 'btn-primary'}}" [disabled]="!form.valid">
        {{'FORGOT_PASSWORD.BUTTON_SUBMIT' | translate}} <span class="loader" *ngIf="loading"></span>
      </button>
    </div>
  </form>
</div>

<div *ngIf="resultShow" [ngClass]="{'henterpant-mode': henterPantMode, 'gipant-mode': giPantMode}">
  <h2 class="title">{{'FORGOT_PASSWORD.SUCCESS.TITLE' | translate}}</h2>
  <p class="description">
    {{'FORGOT_PASSWORD.SUCCESS.LINE_1' | translate}}
  </p>
  <p class="description">{{'FORGOT_PASSWORD.SUCCESS.LINE_2' | translate}}</p>
  <p class="description">{{'FORGOT_PASSWORD.SUCCESS.LINE_3' | translate}}</p>
  <p class="description" [innerHTML]="'FORGOT_PASSWORD.SUCCESS.LINE_4' | translate"></p>
</div>
